import {
    GET_ACCOUNT_LIST_FAILURE,
    GET_ACCOUNT_LIST_REQUEST,
    GET_ACCOUNT_LIST_SUCCESS,
    GET_PATIENT_LIST_FAILURE,
    GET_PATIENT_LIST_REQUEST,
    GET_PATIENT_LIST_SUCCESS,
    GET_USER_LIST_FAILURE,
    GET_USER_LIST_REQUEST,
    GET_USER_LIST_SUCCESS,
    POST_UPLOAD_DATA_FAILURE,
    POST_UPLOAD_DATA_REQUEST,
    POST_UPLOAD_DATA_SUCCESS,
    PROCESS_UPLOAD_DATA_FILE_FAILURE,
    PROCESS_UPLOAD_DATA_FILE_REQUEST,
    PROCESS_UPLOAD_DATA_FILE_SUCCESS
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: undefined,
    accountList: [],
    userList: [],
    patientList: [],
    error: null,
    message: undefined
};

export default ( state = INIT_STATE, action ) => {
    switch ( action.type ) {
        case GET_ACCOUNT_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_ACCOUNT_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                accountList: action.payload.accountList,
                isInitialFetch: false,
            };
        case GET_ACCOUNT_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case GET_USER_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                isInitialFetch: true,
                error: null,
            };

        case GET_USER_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                userList: action.payload.userList,
                isInitialFetch: false,
            };
        case GET_USER_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case GET_PATIENT_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                isInitialFetch: true,
                error: null,
            };
        case GET_PATIENT_LIST_SUCCESS:
            return {
                ...state,
                patientList: action.payload.patientList,
                message: null,
                error: null,
                isLoading: false,
                isInitialFetch: false,
            };
        case GET_PATIENT_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case POST_UPLOAD_DATA_REQUEST:
            return {
                ...state,
                isLoading: true,
                isInitialFetch: true,
                error: null,
            };
        case POST_UPLOAD_DATA_SUCCESS:
            return {
                ...state,
                message: null,
                error: null,
                isLoading: false,
                isInitialFetch: false,
            };
        case POST_UPLOAD_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case PROCESS_UPLOAD_DATA_FILE_REQUEST:
            return {
                ...state,
                isLoading: true,
                isInitialFetch: true,
                error: null,
            };
        case PROCESS_UPLOAD_DATA_FILE_SUCCESS:
            return {
                ...state,
                message: null,
                error: null,
                isLoading: false,
                isInitialFetch: false,
            };
        case PROCESS_UPLOAD_DATA_FILE_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
};
